export default {
  1: {
    nameHY: 'բնակարան',
    nameEN: 'apartment',
    nameRU: 'квартира',
  },
  2: {
    nameHY: 'առանձնատուն',
    nameEN: 'house',
    nameRU: 'жилой дом',
  },
  3: {
    nameHY: 'ամառանոց',
    nameEN: 'cottage',
    nameRU: 'коттедж',
  },
  4: {
    nameHY: 'գրասենյակ',
    nameEN: 'office',
    nameRU: 'офис',
  },
  5: {
    nameHY: 'ուսումնական շենքեր',
    nameEN: 'edu buildings',
    nameRU: 'учебные здания',
  },
  6: {
    nameHY: 'մանրածախ առևտրի կենտրոն',
    nameEN: 'sales room',
    nameRU: 'помещение продаж',
  },
  7: {
    nameHY: 'մեծածախ առևտրի կենտրոն',
    nameEN: 'wholesales room',
    nameRU: 'помещение для оптовых продаж',
  },
  8: {
    nameHY: 'գործարան',
    nameEN: 'factory',
    nameRU: 'фабрика',
  },
  9: {
    nameHY: 'պահեստ',
    nameEN: 'warehouse',
    nameRU: 'склад',
  },
  10: {
    nameHY: 'արտադրական տարածք',
    nameEN: 'industrial area',
    nameRU: 'промышленная зона',
  },
  11: {
    nameHY: 'շինություն',
    nameEN: 'building',
    nameRU: 'здания',
  },
  12: {
    nameHY: 'հյուրանոց',
    nameEN: 'hotel',
    nameRU: 'отель',
  },
  13: {
    nameHY: 'գրասենյակային սարքավորումներ',
    nameEN: 'office equipment',
    nameRU: 'офисная техника',
  },
  14: {
    nameHY: 'կահույք',
    nameEN: 'furniture',
    nameRU: 'мебель',
  },
  15: {
    nameHY: 'ներքին հարդարման աշխատանանքներ',
    nameEN: 'interior work',
    nameRU: 'внутренние работы',
  },
  16: {
    nameHY: 'արտադրական սարքավորումներ',
    nameEN: 'industrial equipment',
    nameRU: 'промышленное оборудование',
  },
  17: {
    nameHY: 'այլ',
    nameEN: 'other',
    nameRU: 'другой',
  },
  18: {
    nameHY: 'սարքավորումներ',
    nameEN: 'equipment',
    nameRU: 'оборудование',
  },
  19: {
    nameHY: 'գիպսի արտադրության սարքավորում',
    nameEN: 'industrial equipment',
    nameRU: 'промышленное оборудование',
  },
  20: {
    nameHY: 'շրջանառու միջոցներ',
    nameEN: 'working capital',
    nameRU: 'рабочий капитал',
  },
  21: {
    nameHY: 'արևային պանելներ',
    nameEN: 'solar panels',
    nameRU: 'солнечные панели',
  },
};
